import { money } from "./format";

// Assessor / public-record characteristics as an SSD-23 label/value fact grid.
// The photo, address, and headline stats (beds/baths/sqft/…) live in the
// RevealedReport hero, so this section carries the record-level facts. Pure
// presentational; renders nothing when there's no property data.
const FIELDS = [
  { key: "market_value", label: "Market value", fmt: money },
  { key: "land_value", label: "Land value", fmt: money },
  { key: "assessment_year", label: "Assessment year", fmt: (v) => v },
  { key: "owner", label: "Owner of record", fmt: (v) => v },
  { key: "beds", label: "Bedrooms", fmt: (v) => v },
  { key: "baths", label: "Bathrooms", fmt: (v) => v },
  { key: "sqft", label: "Building area", fmt: (v) => `${v.toLocaleString()} sqft` },
  { key: "year_built", label: "Year built", fmt: (v) => v },
  { key: "lot_size_acres", label: "Lot size", fmt: (v) => `${v} ac` },
  { key: "garage_cars", label: "Garage", fmt: (v) => `${v} car` },
];

const present = (v) => v !== undefined && v !== null && v !== "";

export default function PropertyDetails({ property, heading = "Property details" }) {
  if (!property) return null;
  const rows = FIELDS.filter((f) => present(property[f.key]));
  if (rows.length === 0) return null;

  return (
    <section className="ssc-report-section">
      {heading && <h3>{heading}</h3>}
      <div className="ssc-report-facts">
        {rows.map((f) => (
          <div key={f.key} className="ssc-report-fact">
            <span className="ssc-report-fact-k">{f.label}</span>
            <span className="ssc-report-fact-v">{f.fmt(property[f.key])}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
